<template lang="pug">
  y-dialog(v-if="showDialog" v-model="showDialog" persistent max-width=600 content-class="round-2xl")
    v-card
      v-card-title.px-4
        .text-2l.font-semibold.neutral700--text Review Invites
      v-divider
      v-card-text.py-6
        v-form(ref="form")
          //- Name
          div.text-sm.font-semibold.neutral700--text Name
          v-text-field.text-sm.round-xl.mt-2(v-model="name" placeholder="Insert Customer Name" outlined dense height="48" :rules="rules.not_empty" hide-details="auto")
          //- Phone
          div.text-sm.font-semibold.neutral700--text.mt-5 Phone
          phone-input.mt-2(v-model="phone" ref="phoneInput" required)
      v-card-actions
        v-spacer
        v-btn.button-md.underline.mr-4(text @click="handleCancel") {{ $t('cancel') }}
        v-btn.button-md(color="neutral700" depressed dark :loading="isLoading" @click.stop="handleSaveData") {{ $t('save') }}
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import PhoneInput from "@/components/clinic/custom/PhoneInput.vue";
import {isMarketingMerchantApp} from "@/utils";

export default {
  components: {
    PhoneInput
  },
  props: {
    open: {
      type: Boolean,
    },
  },
  data() {
    return {
      isLoading: false,
      rules: {
        not_empty: [v => (v != null && v.toString().trim().length) || 'This field is required'],
      },
      name: null,
      phone: null,
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
  },
  methods: {
    ...mapActions(['showMessage']),
    async handleSaveData() {
      if (!this.$refs.form.validate()) {
        this.showMessage(['error', this.$t('error_message.please_fill_out_all_required')])
        return
      }
      this.isLoading = true
      try {
        const payload = {
          name: this.name,
          phone: this.phone
        }
        const endpoint = `/reviews/${this.company.slug}/invites/`
        const {data} = await this.$axios.post(endpoint, payload)
        this.updateActivityLog(endpoint, payload, data, 'POST', 'Add review invite', data.id)
        this.showMessage(['success', 'Successfully invited customer'])
        this.closeDialog()
      } catch {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.isLoading = false
      }
    },
    closeDialog() {
      this.$emit('close')
      this.showDialog = false
    },
    handleCancel() {
      this.closeDialog()
    },
    updateActivityLog(endpoint, payload, response, method, activity, id) {
      let data = {
        company: this.company.id,
        object_id: id || null,
        object_ref: 'Review invite',
        activity: activity,
        raw_data: {endpoint, payload, response, method}
      }
      if (isMarketingMerchantApp(this.$route)) {
        data.activity = `Merchant-app: ${activity}`
      }
      this.$axios.post('/users/logs', data)
          .catch(() => {
          })
    },
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}

.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>